'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var classnames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var InputText = function InputText(_ref) {
  var error = _ref.error,
      additionalClassName = _ref.className,
      additionalProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, ["error", "className"]);

  var className = classnames__default['default']('ds-atom-text-input-normal', {
    error: error
  }, additionalClassName);
  return /*#__PURE__*/React__default['default'].createElement("input", _rollupPluginBabelHelpers.extends({
    className: className
  }, additionalProps));
};

InputText.propTypes = {
  error: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string
};
InputText.defaultProps = {
  error: false,
  className: ''
};

module.exports = InputText;
